import numbro from "numbro";
import { xlsxExport } from "../../utils/xlsxExport";

export function addThousandSeparated(value) {
  return numbro(value).format({ thousandSeparated: true });
}

export function formatValueWithAverage(str) {
  let splittedValues = str.trim().split(" ");

  const filteredValues = splittedValues.map((elem) => {
    const replacedElem = elem.replace(/\(|\)/g, "");

    if (replacedElem === "--" || replacedElem.endsWith("%")) {
      return replacedElem;
    }

    return addThousandSeparated(replacedElem);
  });

  return `${filteredValues[0]} (${filteredValues[1]})`;
}

export function getExcelRowValue(tableDataUid, displayValue) {
  if (!tableDataUid) {
    return "-";
  }

  if (typeof displayValue === "number") {
    return displayValue;
  } else if (displayValue.endsWith("%")) {
    return displayValue.split("%")[0] / 100;
  } else if (displayValue.endsWith(")")) {
    return formatValueWithAverage(displayValue);
  } else {
    return displayValue;
  }
}

export function getFormat(valueSymbol) {
  return valueSymbol === "%"
    ? {
        xlsxFormat: "percentage",
        pattern: "#,##0%"
      }
    : {
        xlsxFormat: "number",
        pattern: "#,##0.00"
      };
}

export function exportExcelForTimeOfDay({ seriesGroup }) {
  //seriesGroup is combination of several heatmap charts,
  //therefore we need to add empty columns between each chart data in excel
  const headers = [];

  seriesGroup.forEach((group, index) => {
    if (index === 0) {
      headers.push("");
    } else {
      headers.push("", "");
    }
    headers.push(group.timeRange);
  });

  let rows = [];

  let reversedSeriesGroup = seriesGroup.map((elem) => elem.groupData.toReversed());

  reversedSeriesGroup.forEach((heatmapData) => {
    heatmapData.forEach((row, index) => {
      let { name, data } = row;
      if (!rows[index]) {
        rows[index] = [];
      }

      rows[index].push(
        name,
        getExcelRowValue(data[0].modalData.tableDataUid, data[0].displayValue),
        // for width of the column
        "       "
      );
    });
  });

  let valueSymbol = seriesGroup[0].groupData.filter((elem) => elem.name)[0].data[0].valueSymbol;

  let format = getFormat(valueSymbol);

  xlsxExport({
    headers,
    data: rows,
    fileName: "HeatMap",
    columns: headers.map((header) => (header === "" ? {} : format))
  });
}

const formatTimeOfDay = (str) => {
  const [time, timeOfDay, value, average] = str.split(" ");
  let formattedValue = value.replace(/\.0$/, "");

  if (average) {
    return `${time} ${timeOfDay} ${formatValueWithAverage(`${value} ${average}`)}`;
  }
  formattedValue = value.endsWith("%") ? value : addThousandSeparated(formattedValue);
  return `${time} ${timeOfDay} ${formattedValue}`;
};

export const formatTooltip = (str, groupByTimeOfDay) => {
  if (groupByTimeOfDay) {
    return formatTimeOfDay(str);
  }
  const [day, value] = str.split(":");
  let formattedValue = value.replace(/\.0$/, "");
  if (value.endsWith(")")) {
    return `${day}: ${formatValueWithAverage(value)}`;
  }
  formattedValue = value.endsWith("%") ? value : addThousandSeparated(formattedValue);
  return `${day}: ${formattedValue}`;
};

export const addDelimiterToDisplayValue = (dataArr) => {
  return dataArr.map((dataObj) => ({
    ...dataObj,
    data: dataObj.data.map((dataItem) => ({
      ...dataItem,
      displayValue:
        typeof dataItem.displayValue === "number"
          ? addThousandSeparated(dataItem.displayValue)
          : dataItem.displayValue.endsWith(")")
          ? formatValueWithAverage(dataItem.displayValue)
          : dataItem.displayValue
    }))
  }));
};

export const calculateTableHeight = (data) => {
  if (data <= 1) {
    return 130;
  } else if (data >= 2 && data <= 5) {
    return 200;
  }
  return data * 35;
};
